import {createRouter, createWebHistory} from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/summary",
        name: "summary",
        component: function () {
            return import(/* webpackChunkName: "summary" */ "../views/SummaryView.vue");
        },
    },
    {
        path: "/success",
        name: "success",
        component: function () {
            return import(/* webpackChunkName: "summary" */ "../views/SuccessView.vue");
        },
    },
    {path: "/:pathMatch(.*)*", name: "NotFound", component: HomeView},
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

const DEFAULT_TITLE = "tink Cancellation";
router.beforeEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});

export default router;
